import { createSelector } from 'reselect';
import { GlobalState } from '@/redux/store';
import { HouseBillingCurrencySlice } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.types';

const sliceSelector = (state: GlobalState): HouseBillingCurrencySlice => state.houseBillingCurrency;

export const getAvailableCurrencies = createSelector([sliceSelector], (slice) => slice.availableCurrencies);

export const getHouseBillingCurrencyIsLoading = createSelector([sliceSelector], (slice) => slice.loading);

export const getHouseBillingCurrencySaveWasSuccessful = createSelector(
    [sliceSelector],
    (slice) => slice.wasSaveSuccessful
);
